import React, { useState, useEffect } from 'react';
import './BrandBillingNumberField.scss';

const BrandBillingNumberField = props => {
  const { value, prefix, label } = props;
  const [draft, setDraft] = useState(value ?? 0);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => setDraft(value ?? 0), [value]);
  const isDirty = String(draft) !== String(value ?? 0) && draft !== '';

  const save = async () => {
    setIsSaving(true);
    await props.onSave(Number(draft));
    setIsSaving(false);
  };

  return (
    <span className='brand-billing-numberfield'>
      {!!prefix && <span className='brand-billing-numberfield-prefix'>{prefix}</span>}
      <input
        className='brand-billing-numberfield-input'
        aria-label={label}
        type='number'
        min={0}
        value={draft}
        disabled={isSaving}
        onChange={e => setDraft(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && isDirty && save()}
      />
      {isDirty && (
        <button className='brand-billing-numberfield-save' disabled={isSaving} onClick={save}>
          {isSaving ? '…' : 'Save'}
        </button>
      )}
    </span>
  );
};

export default BrandBillingNumberField;
